import {serviceTrackingService} from '../../_services'

export default {
  state: {
    myServiceTrackings: [],
    myApprovedServiceTrackings: [],
    allServiceTrackings: [],
    maxServiceTrackings: 50,
    maxApprovedServiceTrackings: 50
  },
  mutations: {
    setMyServiceTrackings (state, payload) {
      state.myServiceTrackings = payload
    },
    setMyApprovedServiceTrackings (state, payload) {
      state.myApprovedServiceTrackings = payload
    },
    setEditedServiceTrackingOfMy (state, payload) {
      const foundIndex = state.myServiceTrackings.findIndex(servieTracking => servieTracking.id === payload.id)
      if (foundIndex > -1) state.myServiceTrackings.splice(foundIndex, 1, payload)
    },
    setAllServiceTrackings (state, payload) {
      state.allServiceTrackings = payload
    },
    setEditedServiceTrackingOfAll (state, payload) {
      state.allServiceTrackings.forEach(serviceTrackingMonth => {
        serviceTrackingMonth.userGroupedServiceTrackings.forEach(serviceTrackingssOfUsers => {
          const foundIndex = serviceTrackingssOfUsers.usersServiceTracking.findIndex(servieTracking => servieTracking.id === payload.id)
          if (foundIndex > -1) serviceTrackingssOfUsers.usersServiceTracking.splice(foundIndex, 1, payload)
        })
      })
    },
    addMyServiceTracking (state, payload) {
      if (state.myServiceTrackings.length === state.maxServiceTrackings) {
        state.myServiceTrackings.push(payload)
        state.maxServiceTrackings += 1
      }
    },
    addMyServiceTrackings (state, payload) {
      if (state.myServiceTrackings.length <= (state.maxServiceTrackings - payload.length)) {
        payload.forEach(newServiceTracking => state.myServiceTrackings.push(newServiceTracking))
      }
    },
    addMyApprovedServiceTrackings (state, payload) {
      if (state.maxApprovedServiceTrackings >= payload.length) {
        state.myApprovedServiceTrackings = state.myApprovedServiceTrackings.concat(payload)
      }
    },
    addAllServiceTrackings (state, payload) {
      if (state.allServiceTrackings.length <= (state.maxServiceTrackings - payload.length)) {
        // Month level
        payload.forEach(responseMonth => {
          if (state.allServiceTrackings.length === 0) {
            state.allServiceTrackings.push(responseMonth)
          } else {
            let wasDateModified = false
            state.allServiceTrackings.forEach(currentMonth => {
              // User group level
              if (currentMonth.month === responseMonth.month) {
                responseMonth.userGroupedServiceTrackings.forEach(value => {
                  let wasAdded = false
                  currentMonth.userGroupedServiceTrackings.forEach(currentGroup => {
                    if (value.userId === currentGroup.userId) {
                      value.usersServiceTracking.forEach(tracking => currentGroup.usersServiceTracking.push(tracking))
                      wasAdded = true
                      wasDateModified = true
                    }
                  })
                  if (!wasAdded) {
                    currentMonth.userGroupedServiceTrackings.push(value)
                    wasDateModified = true
                  }
                })
              }
            })
            if (!wasDateModified) {
              state.allServiceTrackings.push(responseMonth)
            }
          }
        })
      }
    },
    setMaxServiceTrackings (state, payload) {
      state.maxServiceTrackings = payload
    },
    setMaxApprovedServiceTrackings (state, payload) {
      state.maxApprovedServiceTrackings = payload
    },
    removeServiceTrackingOfAll (state, payload) {
      state.allServiceTrackings.forEach((serviceTrackingMonth, monthIndex) => {
        serviceTrackingMonth.userGroupedServiceTrackings.forEach((serviceTrackingssOfUsers, userIndex) => {
          const foundIndex = serviceTrackingssOfUsers.usersServiceTracking.findIndex(servieTracking => servieTracking.id === payload)
          if (foundIndex > -1) {
            serviceTrackingssOfUsers.usersServiceTracking.splice(foundIndex, 1)
            if (serviceTrackingssOfUsers.usersServiceTracking.length === 0) {
              serviceTrackingMonth.userGroupedServiceTrackings.splice(userIndex, 1)
            }
          }
        })
        if (serviceTrackingMonth.userGroupedServiceTrackings.length === 0) {
          state.allServiceTrackings.splice(monthIndex, 1)
        }
      })
    },
    removeServiceTrackingFromMyApproved (state, payload) {
      const foundIndex = state.myApprovedServiceTrackings.findIndex(servieTracking => servieTracking.id === payload.id)
      if (foundIndex > -1) state.myApprovedServiceTrackings.splice(foundIndex, 1)
    }
  },
  actions: {
    loadMyServicesTrackings ({dispatch, commit}, filter) {
      dispatch('startDataLoading')
      serviceTrackingService.getMyServicesTrackings(filter.page, filter.size, false)
        .then(response => {
          commit('setMaxServiceTrackings', response.data.totalElements)
          commit('addMyServiceTrackings', response.data.content)
        })
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    loadMyApprovedServicesTrackings ({dispatch, commit}, filter) {
      dispatch('startDataLoading')
      serviceTrackingService.getMyServicesTrackings(filter.page, filter.size, true)
        .then(response => {
          commit('setMaxServiceTrackings', response.data.totalElements)
          commit('addMyApprovedServiceTrackings', response.data.content)
        })
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    loadAllServicesTrackings ({dispatch, commit}, filter) {
      dispatch('startDataLoading')
      serviceTrackingService.getAllServicesTrackings(filter.page, filter.size)
        .then(response => {
          commit('setMaxApprovedServiceTrackings', response.data.totalElements)
          commit('addAllServiceTrackings', response.data.content)
        })
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    approveServiceTracking ({dispatch, commit}, serviceTracking) {
      dispatch('startDataLoading')
      serviceTrackingService.approveServiceTracking(serviceTracking.id)
        .then(() => commit('removeServiceTrackingOfAll', serviceTracking.id))
        .then(() => dispatch('showNotification', {
          title: 'Zeiterfassung erfolgreich genehmigt.',
          type: 'primary'
        }))
        .catch(error => {
          serviceTracking.approved = false
          commit('setEditedServiceTrackingOfAll', serviceTracking)
          dispatch('handleError', error)
        })
        .finally(() => dispatch('stopDataLoading'))
    },
    resetServiceTrackings ({commit}) {
      commit('setMyServiceTrackings', [])
      commit('setAllServiceTrackings', [])
      commit('setMaxServiceTrackings', 50)
    },
    resetApprovedServiceTrackings ({commit}) {
      commit('setMyApprovedServiceTrackings', [])
      commit('setMaxApprovedServiceTrackings', 60)
    },
    addServiceTracking ({dispatch, commit}, serviceTracking) {
      dispatch('startLoading')
      serviceTrackingService.createServiceTracking(serviceTracking)
        .then(response => {
          commit('addMyServiceTracking', response.data)
        })
        .then(() => dispatch('showNotification', {
          title: 'Zeitnachweis erfolgreich angelegt.',
          type: 'primary'
        }))
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopLoading'))
    },
    updateServiceTrackingOfMy ({dispatch, commit, rootState}, serviceTracking) {
      dispatch('startLoading')
      serviceTrackingService.updateServiceTracking(serviceTracking)
        .then(response => {
          if (rootState.user.user.role === 'ADMIN') {
            commit('setEditedServiceTrackingOfAll', response.data)
          } else {
            commit('removeServiceTrackingFromMyApproved', response.data)
            commit('setEditedServiceTrackingOfMy', response.data)
          }
        })
        .then(() => dispatch('showNotification', {
          title: 'Zeitnachweis erfolgreich geändert.',
          type: 'primary'
        }))
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopLoading'))
    }
  },
  getters: {
    myServiceTrackings (state) {
      return state.myServiceTrackings
    },
    myApprovedServiceTrackings (state) {
      return state.myApprovedServiceTrackings
    },
    allServiceTrackings (state) {
      return state.allServiceTrackings
    },
    maxServiceTrackings (state) {
      return state.maxServiceTrackings
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/service-tracking/index.js